const CalendarTimeHeader = ({ date, localizer, culture }) => {
  const dayShort = localizer.format(date, "EEE", culture).toUpperCase();
  const dayNumber = localizer.format(date, "d", culture);

  return (
    <div className="rbc-gcal-time-header">
      <span className="rbc-gcal-time-header-day">{dayShort}</span>
      <span className="rbc-gcal-time-header-date">{dayNumber}</span>
    </div>
  );
};

export default CalendarTimeHeader;
